import { render, staticRenderFns } from "./MoveButtons.vue?vue&type=template&id=4830465e&scoped=true&"
import script from "./MoveButtons.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MoveButtons.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MoveButtons.vue?vue&type=style&index=0&id=4830465e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4830465e",
  null
  
)

export default component.exports